module.exports = __webpack_public_path__ + "20250721160708/img/suiji_icon.635e56e8.png";